import styled from 'styled-components';

export const Modal = styled.section`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 8;

  @media ${({ theme }) => theme.devices.mobile} {
    padding: 0;
    align-items: flex-end;
  }
`;

export const Group = styled.div`
  position: relative;
  width: 100%;
  max-width: 460px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 48px 40px;
  background-color: ${({ theme }) => theme.colors.grey[700]};
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${({ theme }) => theme.devices.mobile} {
    padding: 32px 24px 40px;
    border-radius: 24px 24px 0 0;
    max-height: 95vh;
  }

  .close {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 16px;
    right: 16px;
    padding: 10px;
    border-radius: 100%;
    background-color: rgba(255, 255, 255, 0.15);
    border: 0;
    cursor: pointer;

    img {
      width: 16px;
      height: 16px;
    }
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const OptionGroup = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  margin-bottom: 4px;
`;

export const Option = styled.button`
  flex: 1;
  padding: 12px 8px;
  border-radius: 12px;
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.primary.main : theme.colors.grey[500]};
  background-color: ${({ $active }) =>
    $active ? 'rgba(228, 38, 33, 0.15)' : 'transparent'};
  cursor: pointer;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary.main : theme.colors.grey.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  transition:
    border-color 0.2s,
    background-color 0.2s;
`;

export const BillingGroup = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

export const BillingOption = styled.button`
  flex: 1;
  padding: 10px 8px;
  border-radius: 12px;
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.primary.main : theme.colors.grey[500]};
  background-color: ${({ $active }) =>
    $active ? 'rgba(228, 38, 33, 0.15)' : 'transparent'};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary.main : theme.colors.grey.white};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition:
    border-color 0.2s,
    background-color 0.2s;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const InputField = styled.div`
  width: 100%;

  input {
    width: 100%;
    padding: 12px 20px;
    border-radius: 32px;
    border: 1px solid ${({ theme }) => theme.colors.grey.white};
    background-color: ${({ theme }) => theme.colors.grey[100]};
    font-size: 16px;

    &:focus {
      outline: none;
    }
  }
`;

export const PeriodInfo = styled.div`
  width: 100%;
  padding: 12px 20px;
  border-radius: 32px;
  border: 1px solid ${({ theme }) => theme.colors.grey[500]};
  background-color: transparent;

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.grey[200]};

    strong {
      color: ${({ theme }) => theme.colors.grey.white};
    }
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 18px;
  border-radius: 24px;
  border: 0;
  background: ${({ theme }) => theme.colors.gradient.fullX};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
  transition: opacity 0.3s;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  h4 {
    font-size: 24px;
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 400;
  }
`;

export const QuantitySelector = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 20px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.grey[500]};

  button {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.grey[500]};
    background: transparent;
    color: ${({ theme }) => theme.colors.grey.white};
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;

    &:disabled {
      opacity: 0.3;
      cursor: default;
    }
  }
`;

export const QuantityInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
`;

export const PaymentInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  text-align: center;
`;

export const PixQrCode = styled.img`
  width: 200px;
  height: 200px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.grey.white};
  padding: 8px;
`;

export const PixCopyPaste = styled.div`
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.grey[500]};
  background-color: ${({ theme }) => theme.colors.grey[700]};
  word-break: break-all;
  text-align: left;

  span {
    font-size: 11px;
    color: ${({ theme }) => theme.colors.grey[200]};
    font-family: monospace;
  }
`;

export const CopyButton = styled.button`
  width: 100%;
  padding: 14px;
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.colors.primary.main};
  background: transparent;
  color: ${({ theme }) => theme.colors.primary.main};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(228, 38, 33, 0.1);
  }

  h4 {
    font-size: 18px;
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 400;
  }
`;

